import React, { Component } from 'react';
import { ButtonToolbar, Button, Grid, Row, Col } from 'react-bootstrap';

import { LinesHelper } from './helpers/LinesHelper';

export class TmlMissingConfigs extends Component {
    renderStopsMissingConfigs(config) {
        if(!Array.isArray(config.lines)) {
            return (
                <div className="missing-config-item" key={config.code}>
                    {config.code} # N�o foram encontradas linhas associadas
                </div>
            );
        }

        return (
            <div className="missing-config-item" key={config.code}>
                {config.code} # {config.lines.map(line => `${line.line} - ${LinesHelper.getOrientationLabel(line.orientation)}`).join(" | ")}
            </div>
        );
    }

    render() {
        const { configs } = this.props;

        const lineConfigs = configs.filter(config => 0 === config.type);
        const stopConfigs = configs.filter(config => 1 === config.type);

        return (
            <React.Fragment>
                <Grid fluid>
                    <Row>
                        <Col><b>Linhas</b></Col>
                    </Row>
                    <Row>
                        <Col>
                            {lineConfigs.map(config => <div className="missing-config-item" key={config.code}>{config.code}</div>)}
                        </Col>
                    </Row>

                    <Row className="margin-top-15">
                        <Col><b>Paragens</b></Col>
                    </Row>
                    <Row>
                        <Col>
                            {stopConfigs.map(config => this.renderStopsMissingConfigs(config))}
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar className="margin-top-15">
                    <Button onClick={() => this.props.onContinue()}> CONTINUAR </Button>
                    <Button onClick={() => this.props.onCancel()}> CANCELAR </Button>
                </ButtonToolbar>
            </React.Fragment>
        );
    }
}
